module.exports = __webpack_public_path__ + "media/Q9.fbb7e4e0.mp4";